import { Pagination } from "@mui/material";
import { useState } from "react";

export default function PageSelector({ currentPage, totalPages, onPageChange }) {
  const [loading, setLoading] = useState(false);

  const handlePageChange = (event, newPage) => {
    setLoading(true);
    onPageChange(newPage);
    setLoading(false);
  };

  return (
    <div>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        color="primary"
      />
      {loading && <p>Loading...</p>}
    </div>
  );
}
